<template>
<div id="MOES65">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <img id="photo" src="./img/65/65_photo.png"/><br>
        <img id="photo" src="./img/65/65_str.png"/>
      </div>
      <div id="desc" class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <div><h2 style="color: #fff">{{msg}}</h2></div>
        <p class="text">
          {{text}}
        </p>
		<ul>
			<li v-for="i in item2">
				{{i}}
			</li>
		</ul>
		<table id="info">
			<thead>
				<tr>
					<th v-for="item in NameTableSecond">{{item}}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in item_table">
					<td :colspan="item.value ? 1 : 2">{{item.name}}</td>
					<td v-if="item.value">{{item.value}}</td>
				</tr>
			</tbody>
		</table>
      </div>
    </div>
  </div>
    <div id="nineteen">

    </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Модульное оптико-электронное средство МОЭC-65',
	  text: 'Объектив представляет собой малоапертурный катадиоптрический широкопольный оптический прибор высокой светосилы со сферической оптикой, который выполнен по системе Шенкера с трехлинзовым полноапертурным корректором, с задним расположением фотоприёмного устройства в фокусе Кассегрена. Компоновка  и применённая оптическая схема  позволяют  использовать фотоприёмную аппаратуру произвольных габаритов и, в силу размещения вторичного зеркала на линзе полноапертурного корректора, избежать применения системы механических конструктивных элементов крепления вторичного зеркала - растяжек, что исключает помехи от них на изображении, и позволяет эффективно обнаруживать слабые точечные объекты вблизи ярких источников света (звезд) в поле зрения.',
	  item2: ['технологичность в производстве, стабильность и сохраняемость во времени качества даваемого изображения, связанные с применением оптических элементов исключительно со сферическими поверхностями;','применение закрытого корпуса (трубы) объектива, предохраняющего оптические элементы от воздествия неблагоприятных факторов окружающей среды;', 'применение в оптической схеме зеркала Манжена с внутренним переотражением, что позволяет применить серебро (с последующей его защитой для долговременного сохранения свойств) как материал для нанесения зеркального отражающего покрытия с коэффициентом отражения свыше 0.9 и расширенным спектральным диапазоном.'],
      NameTableSecond: ['Параметры и характеристики (свойства)', 'Показатели (значения)'],
      item_table:[
				{
					name: 'Диаметр входного зрачка, мм',
					value: '650'
				},
				{
					name: 'Эффективное фокусное  расстояние, мм',
					value: '1300'
				},
				{
					name: 'Угловой диаметр поля зрения, град.',
					value: '3.8'
				},
				{
					name: 'Линейный диаметр поля зрения, мм',
					value: '86.3'
				},
				{
					name: 'Задний отрезок, мм',
					value: '159'
				},
				{
					name: 'Длина с блендой/без бленды, мм',
					value: '1873/1295'
				},
				{
					name: 'Диаметр наибольший (с блендой), мм',
					value: '730'
				},
				{
					name: 'Масса объектива, кг, не более',
					value: '230'
				},
				{
					name: 'Ожидаемое проницание за 10 с экспозиции на ФПУ, не хуже, зв. величина',
					value: '18.5m'
				},
			],

}
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
#MOES65 {
    height: 100%;
    color: white;
}
img#photo{
  margin-top: 3%;
  width: 90%;
}
div #caption{
	color: #78daff;
	opacity: 0.9;
	text-decoration: underline;
}
div#desc{
  width: 100%;
}
div#desc p.text{
  text-align: justify;
}
div#desc ul{
	list-style: none;
	text-align: justify;
}
div#desc ul li::before {
	content: "-";
}
table#info{
	margin-top: 15%;
	table-layout: fixed;
}
</style>
